import apiHandler from "../core/apiHandler";

// 📌 Todas las rutas estarán bajo /api/menus
const menuApi = apiHandler("menus");

export default menuApi;
